import React from "react";
import VideoGuides from "./VideoGuides/VideoGuides";
import SupportingInformation from "./SupportingInformation/SupportingInformation";
import TabsOn from "../../Components/Tabs/Tabs";
import "./Resources.css";
import { AiOutlineFileSearch } from "react-icons/ai";

const ResourceLogo = "/assets/Resource-edit.svg";
const VideoLogo = "/assets/video_horizontal.svg";
const Supporting = "/assets/Info-folder.svg";

const Resources = () => {
  const tabNames = [
    { name: "Video Guides", Icon: <img src={VideoLogo} alt="videoLogo" /> },
    {
      name: "Supporting Information",
      Icon: <img src={Supporting} alt="supportingInformation" />,
    },
  ];
  return (
    <div className="resources-div">
      <div className="resources-logo">
        {/* <img src={ResourceLogo} alt="resourceLogo" /> */}
        <AiOutlineFileSearch className="sideIcon-size" />
        <h3>Get Started</h3>
      </div>

      <div className="resouce-tabs">
        <div className="my-steptabs">
          <TabsOn size={"large"} tabNames={tabNames}>
            <VideoGuides />
            <SupportingInformation />
          </TabsOn>
        </div>
      </div>
    </div>
  );
};

export default Resources;
